import { LazyRequestAccessConfirmationModal } from './LazyRequestAccessConfirmationModal';
import React from 'react';
import Dialog from 'app/scripts/views/lib/dialog';

export const OpenAutoInviteDialog = (
  inviteMemberId: string,
  boardId: string,
) => {
  Dialog.show({
    reactElement: (
      <LazyRequestAccessConfirmationModal
        boardId={boardId}
        idMember={inviteMemberId}
        onClose={Dialog.hide}
      />
    ),
    maxWidth: 550,
    displayType: 'auto-invite-dialog',
  });
};
